import routes from "@/lib/routes";
import styles from "@/styles/Header.module.scss";
import classnames from "classnames";
import dynamic from "next/dynamic";
import Link from "next/link";
import { useRouter } from "next/router";
import { memo, useCallback } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LogoSPOOX = dynamic(() => import("../../svgs/logo_spoox.svg"), {
  loadableGenerated: {
    webpack: () => [require.resolveWeak("../../svgs/logo_spoox.svg")]
  }
});
function HeaderLogo(_ref) {
  let {
    noTransition
  } = _ref;
  const router = useRouter();
  const href = noTransition ? "#" : routes.home;
  const handleClick = useCallback(e => {
    if (noTransition) {
      e.preventDefault();
      return false;
    }
  }, [noTransition]);
  const headerPageReload = router.asPath.includes(routes.restricted);
  return /*#__PURE__*/_jsxs("div", {
    className: classnames(styles.logoWrapper),
    children: [!headerPageReload && /*#__PURE__*/_jsx(Link, {
      href: href,
      onClick: handleClick,
      children: /*#__PURE__*/_jsx(LogoSPOOX, {
        className: styles.logoSVG
      })
    }), headerPageReload && /*#__PURE__*/_jsx("a", {
      href: href
    })]
  });
}
export default /*#__PURE__*/memo(HeaderLogo);